import { menuAdapter } from '@/adapters/menu';

export const useMenuStore = defineStore({
  id: 'menu',
  state: () => ({
    headerMenu: null,
  }),
  actions: {
    fetchMenu() {
      return useRequest('/menus/header').then((data) => {
        this.headerMenu = menuAdapter(data);
        return this.headerMenu;
      });
    },
  },
});
